<template>
  <div>
    <section class="section is-title-bar">
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <ul>
              <li>Familles</li>
            </ul>
          </div>
        </div>
        <div class="level-right">
          <div class="level-item">
            <div class="buttons is-right">
              <router-link to="/famille/ajouter" class="button is-primary">
                <span class="icon"><plus-icon /></span>
                <span>Ajouter</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section is-main-section">
      <div class="card has-table" v-if="familys.length >= 1">
        <div class="card-content">
          <div class="b-table has-pagination">
            <div class="table-wrapper has-mobile-cards">
              <table
                class="table is-fullwidth is-striped is-hoverable is-fullwidth"
              >
                <thead>
                  <tr>
                    <th class="is-checkbox-cell">
                      <label class="b-checkbox checkbox">
                        <input type="checkbox" value="false" />
                        <span class="check"></span>
                      </label>
                    </th>
                    <th>Nom de la famille</th>
                    <th>Ordre</th>
                    <th></th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="family in familys" v-bind:key="family._id">
                    <td class="is-checkbox-cell">
                      <label class="b-checkbox checkbox">
                        <input type="checkbox" value="false" />
                        <span class="check"></span>
                      </label>
                    </td>

                    <td data-label="Nom">{{ family.name }}</td>

                    <td data-label="Ordre">
                      {{ family.order }}
                    </td>
                    <td class="is-actions-cell">
                      <div class="buttons is-right">
                        <router-link
                          :to="{ name: 'family', params: { id: family._id } }"
                        >
                          <button
                            class="button is-small is-primary"
                            type="button"
                          >
                            <span class="icon"><eye-icon /></span></button
                        ></router-link>
                        <DeleteButton @confirm="removefamily(family._id)" />
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>

      <div class="card has-table" v-if="familys.length === 0">
        <div class="card-content">
          <section class="section">
            <div class="content has-text-grey has-text-centered">
              <p>
                <span class="icon is-large"
                  ><i class="mdi mdi-emoticon-sad mdi-48px"></i
                ></span>
              </p>
              <p v-if="!loading">Aucune famille</p>
              <p v-else>Chargement en cours...</p>
            </div>
          </section>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import axios from "axios";
import DeleteButton from "../components/DeleteButton.vue";

export default {
  data() {
    return {
      loading: true,
      familys: [],
    };
  },
  methods: {
    async removefamily(id) {
      const resp = await axios.post(
        this.URL_API_SERVER + "/admin/familys/remove",
        {
          id,
        }
      );
      if (resp.status === 200 && resp.data.result === "ok") {
        this.$router.go();
      }
    },
  },
  created() {
    const fetchData = async () => {
      const { data: resp } = await axios.get(
        this.URL_API_SERVER + "/restricted/familys/all"
      );
      this.loading = false;
      this.familys = resp.familys;
    };

    fetchData();
  },

  components: { DeleteButton },
};
</script>
